import FoldersLayout, {
  FoldersLayoutTop,
} from '@chegg-wt/core/components/Layouts/Folders'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import { EB_PRODUCT_NAME } from '@chegg-wt/core/constants/site'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import messages from '../copy/messages'

const Folders: NextPageWithLayout = () => {
  useOnUnloadTimeOnPage()
  return <FoldersLayout copy={messages} siteName={EB_PRODUCT_NAME} />
}
Folders.getPageLayout = (page) => getLvpLayout(page, () => <FoldersLayoutTop />)

export default Folders
